import { jsonp, ajax } from 'ThreeTerminal_base/base';

const md5 = require('@ifeng/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 疫情页分享数
export const getVoteNum = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });

    return data.data && data.data.browse && data.data.browse[key] ? data.data.browse[key] : '';
};

// 疫情分享
export const vote = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1;
};

// 疫情分享数设置
export const voteSet = async (key, num) => {
    const data = await jsonp('//survey.news.ifeng.com/api/increby', {
        data: {
            format: 'js',
            key,
            num,
        },
        jsonpCallback: 'setto',
        cache: false,
    });

    return data;
};

// 疫情地方内容
export const getAreaContent = async (prov, id) => {
    const data = await jsonp(`https://shankapi.ifeng.com/c/api/getAreaContent/${id}/20/${prov}`, {
        jsonpCallback: prov,
        cache: false,
    });

    if (data.code === 0 && data.data && data.data.length > 0) {
        return data.data;
    }

    return [];
};

// 两会2019政府报告
export const get2019Report = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_464a8670652a3034218f584e2dd5b34a/info/getReport',
        {
            jsonpCallback: 'getReport',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data.data;
    }

    return [];
};

// 两会2020预期目标
export const get2020Task = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_9cabe1dd3effbd18887a7b57d4fdde25/info/getTask',
        {
            jsonpCallback: 'getTask',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data.data;
    }

    return [];
};

// 两会2020政府工作重点
export const get2020Main = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_8fca01a8339aceb9039ea3127d81e934/info/getMain',
        {
            jsonpCallback: 'getMain',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data.data;
    }

    return [];
};

// 北京疫情轨迹
export const getBjRoad = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_4e1244fce43bfee895b50a5bffa033b7/info/getBjRoad',
        {
            jsonpCallback: 'getBjRoad',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return [];
};

// 获取调查数据
export const getSurveyData = async id => {
    return await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: createJsonpCallbackName('getSurveyData'),
        cache: false,
    });
};

// 提交调查数据
export const postSurveyData = async (param, id) => {
    return await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${param}`, {
        data: {
            id,
            act: 'postsurvey',
            surid: id,
        },
        jsonpCallback: createJsonpCallbackName('postSurveyData'),
        cache: false,
    });
};

// 获取作品数据
export const getGalleryData = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_64e20fccc7af0beafb8366d99eca074c/info/getGalleryData',
        {
            jsonpCallback: 'getGalleryData',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return {};
};

// 获取视频信息
export const getVideoInfo = async guid => {
    return await jsonp(`https://tv.ifeng.com/h6/${guid}_getVideoInfo/getVideoById.json`, {
        jsonpCallback: 'getVideoInfo',
        cache: false,
    });
};

// 获取权限列表
export const getPAList = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_40d5d30305ff3526acc2dc59687e7107/info/getPAList',
        {
            jsonpCallback: 'getPAList',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return {};
};

// 获取美国大选2020实时民调数据
export const getPollsData = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_98294ada02e1b888e94e0e27d5616717/info/getPollsData',
        {
            jsonpCallback: 'getPollsData',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return {};
};

// 获取美国大选专题大咖论点和两党争锋数据
export const getElectionData = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_500acc380650a673267122d29eb80162/info/getElectionData',
        {
            jsonpCallback: 'getElectionData',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return {};
};

// 获取美国大选专题焦点新闻内容
export const getFocusNewsData = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/getSpecialArticleList/7uZ62QOr13g/0/5//getFocusNewsData',
        {
            jsonpCallback: 'getFocusNewsData',
            cache: false,
        },
    );

    if (data.code === 0) {
        return data.data;
    }

    return {};
};

const arr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

// 获取美国大选2020开票数据
export const getVotesData = async () => {
    const cache = new Date().getTime();

    const data = await jsonp('https://shankapi.ifeng.com/feedflow/daxuan/info/getVotesData', {
        jsonpCallback: 'getVotesData',
        cache,
        timeout: 10000,
    });

    if (data.code === 0) {
        const all = data.data.data[0];

        if (!data.data.data[0].bidenNum) {
            data.data.data[0].bidenNum = all._bidenNum || 0;
        }

        if (!data.data.data[0].trumpNum) {
            data.data.data[0].trumpNum = all._trumpNum || 0;
        }

        if (!data.data.data[0].otherNum) {
            data.data.data[0].otherNum = all._otherNum || 0;
        }

        if (!data.data.data[0].bidenSum) {
            data.data.data[0].bidenSum = all._bidenSum || 0;
        }

        if (!data.data.data[0].trumpSum) {
            data.data.data[0].trumpSum = all._trumpSum || 0;
        }

        if (!data.data.data[0].otherSum) {
            data.data.data[0].otherSum = all._otherSum || 0;
        }

        // if (!data.data.data[0].bidenRate) {
        //     data.data.data[0].bidenRate = all._bidenRate || 0;
        // }

        // if (!data.data.data[0].trumpRate) {
        //     data.data.data[0].trumpRate = all._trumpRate || 0;
        // }

        // if (!data.data.data[0].otherRate) {
        //     data.data.data[0].otherRate = all._otherRate || 0;
        // }

        data.data.data = [
            data.data.data[0],
            ...data.data.data.slice(1).sort((a, b) => {
                if (arr.indexOf(a.id ? a.id.slice(0, 1) : 'Z') === arr.indexOf(b.id ? b.id.slice(0, 1) : 'Z')) {
                    return arr.indexOf(a.id ? a.id.slice(1) : 'Z') - arr.indexOf(b.id ? b.id.slice(1) : 'Z');
                }

                return arr.indexOf(a.id ? a.id.slice(0, 1) : 'Z') - arr.indexOf(b.id ? b.id.slice(0, 1) : 'Z');
            }),
        ];

        return data.data;
    }

    return {};
};

// 获取中国城市对应表
export const getCityMap = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/yiqing_local_policy_citymap_new/info/getCityMap',
        {
            jsonpCallback: 'getCityMap',
            cache: false,
        },
    );

    if (data.code === 0) {
        const citymap = data.data.citymap;
        const area = Object.keys(citymap).map(item => ({
            value: item,
            label: item,
            children: Object.keys(citymap[item].citylist).map(child => ({
                value: citymap[item].citylist[child].code,
                label: child,
            })),
        }));

        return [...area];
    }

    return [];
};

// 获取隔离政策
export const getPolicy = async code => {
    const data = await jsonp(
        `https://shankapi.ifeng.com/feedflow/coopdoc/yiqing_local_policy_new_${code}/info/getPolicy_${code}`,
        {
            jsonpCallback: `getPolicy_${code}`,
            cache: false,
        },
    );

    if (data.code === 0 && data.data) {
        const item = data.data;

        let policy = '';

        try {
            policy = JSON.stringify(item.policy)
                .slice(1, JSON.stringify(item.policy).length - 1)
                .split('\\r\\n');
        } catch (e) {
            console.error(e);

            policy = [item.policy];
        }

        return {
            policy,
            updateTime: item.update_time.split(' ')[0],
        };
    }

    return {};
};

// 获取中高风险区数据
export const getLevelArea = async area => {
    const data = await jsonp(
        `https://shankapi.ifeng.com/feedflow/coopdoc/yiqing_local_level_new_${area}/info/getLevelArea_${area}`,
        {
            jsonpCallback: `getLevelArea_${area}`,
            cache: false,
        },
    );

    if (data.code === 0 && data.data.list) {
        const list = data.data.list;

        const mid = list.filter(item => item.level === '中风险');
        const high = list.filter(item => item.level === '高风险');

        return {
            mid,
            high,
            updateTime: data.data.update_time.split(' ')[0],
        };
    }

    return {};
};
